import style from './chiploader.module.scss'

export default function ChipLoader() { return <div className={style.chipBox}><div className={style.chipWave}></div></div> }
